import {AlertMessage} from "@plugins-fr/alertMessage";
import {JconfirmTemplateHelper} from "@plugins-fr/JconfirmTemplateHelper";
import Lang from "@vendors-fr/messages";

// 綠界門市更改資訊
export const EcPayChangeStoreData = {
    get: {
        'storeInfo': () => ({
            'packingListId': EcPayChangeStoreData.get.packingListId(),
            'update_store_id': EcPayChangeStoreData.get.storeId(),
            'update_store_name': EcPayChangeStoreData.get.storeName(),
            'update_store_address': EcPayChangeStoreData.get.storeAddress(),
        }),
        'storeId': () => $("input[name='update_store_id']").val(),
        'storeName': () => $("input[name='update_store_name']").val(),
        'storeAddress': () => $("input[name='update_store_address']").val(),
        'packingListId': () => $(".js_modify_packing_list").val(),
    }
}

// paynow 門市更改資訊
export const PayNowChangeStoreData = {
    get: {
        'storeInfo': () => ({
            'packingListId': PayNowChangeStoreData.get.packingListId(),
            'update_storeid': PayNowChangeStoreData.get.storeId(),
            'update_storename': PayNowChangeStoreData.get.storeName(),
            'update_storeaddress': PayNowChangeStoreData.get.storeAddress(),
        }),
        'storeId': () => $(".js_paynow_store_id").val(),
        'storeName': () => $(".js_paynow_store_name").val(),
        'storeAddress': () => $(".js_paynow_store_address").val(),
        'packingListId': () => $(".js_modify_packing_list").val(),
    }
};

// 更改門市: 門市關轉
export class ChangeStore
{
    defaultSetting = {
        'JS_VARS_THEME_STYLE': {},
        'changeStoreButtonClass': '',
        'saveStoreButtonClass': '',
        'changeStoreFormPrefix': '',
        'modifyPackingListId': '',
        'changeStoreAjaxUrl': '',
        'orderNo': '',
        'orderQueryToken': '',
        'successCallback': (response) => {}
    }

    constructor(changeStoreData, setting) {
        this.changeStoreData = changeStoreData;
        this.setting = Object.assign({}, this.defaultSetting, setting);
    }

    bindEvents() {
        this.bindClickChangeStoreButtonEvent();
        this.bindClickSaveStoreButtonEvent();
    }

    bindClickChangeStoreButtonEvent() {
        const _this = this;
        $(this.setting.changeStoreButtonClass).on('click', function(){
            const pack = $(this).data('pack');
            const target = _this.setting.changeStoreFormPrefix + '_' + pack;

            if (_this.setting.modifyPackingListId != '' && pack != _this.setting.modifyPackingListId) {
                new AlertMessage({
                    'title': '請先完成編輯中的出貨單'
                }).handle();
                return;
            }

            $(target).submit();
        });
    }

    bindClickSaveStoreButtonEvent() {
        const _this = this;
        $(this.setting.saveStoreButtonClass).on('click', function(){
            $.confirm({
                template: JconfirmTemplateHelper.getTemplate({
                    'templateType': '01',
                    'theme': 'el_confirm'
                }),
                columnClass: 'col-lg-5 col-xl-4',
                content: false,
                closeIcon: false,
                icon: 'icon-new_exclaim_circle',
                title: Lang.get('frontend.order.updateStore.check'),
                offsetTop: 0,
                offsetBottom: 0,
                buttons: {
                    cancelButton: {
                        keys: ['esc'],
                        text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.cancel') + '</span>',
                        btnClass: 'btn_cancel btn el_btn md solid el_rounded el_text order-1 m-0',
                    },
                    confirmButton: {
                        keys: ['enter'],
                        text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.success') + '</span>',
                        btnClass: 'btn_confirm btn el_btn md solid el_rounded el_text m-0',
                        action: function() {
                            $.ajax({
                                type: 'POST',
                                url: _this.setting.changeStoreAjaxUrl,
                                data: {
                                    no: _this.setting.orderNo,
                                    order_query_token: _this.setting.orderQueryToken,
                                    update_store_data: _this.changeStoreData.get.storeInfo()
                                },
                                success: function(response){
                                    _this.setting.successCallback(response);
                                },
                                dataType: 'json'
                            });
                            return true;
                        },
                    }
                },
                backgroundDismiss: false,
                onOpenBefore: function() {
                    this.$el.find('.btn_confirm').attr('style', _this.setting.JS_VARS_THEME_STYLE.confirmButtonStyle);
                    this.$el.find('.btn_confirm').data('style', _this.setting.JS_VARS_THEME_STYLE.confirmButtonStyle);
                    this.$el.find('.btn_confirm').data('hover-style', _this.setting.JS_VARS_THEME_STYLE.confirmButtonHoverStyle);

                    this.$el.find('.btn_cancel').attr('style', _this.setting.JS_VARS_THEME_STYLE.cancelButtonStyle);
                    this.$el.find('.btn_cancel').data('style', _this.setting.JS_VARS_THEME_STYLE.cancelButtonStyle);
                    this.$el.find('.btn_cancel').data('hover-style', _this.setting.JS_VARS_THEME_STYLE.cancelButtonHoverStyle);

                    this.$el.find('.btn_cancel, .btn_confirm').hover(
                        function () {
                            $(this).attr('style', $(this).data('hover-style'));
                        },
                        function () {
                            $(this).attr('style', $(this).data('style'));
                        }
                    );
                }
            });

            return false;
        });
    }
}